/* zenarem — interacciones ligeras (sin dependencias) */
(function () {
  'use strict';

  /* 1 · Barra sticky móvil: se oculta cuando el formulario (#pedido) está a la vista */
  function initStickyBar() {
    var bar = document.querySelector('.sticky-m');
    var target = document.getElementById('pedido');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.style.visibility = e.isIntersecting ? 'hidden' : 'visible';
        bar.style.opacity = e.isIntersecting ? '0' : '1';
      });
    }, { threshold: 0.12 });
    io.observe(target);
  }

  /* 2 · Selección de paquete en el formulario (radio o click) */
  function initPackages() {
    var pkgs = document.querySelectorAll('.pkg');
    if (!pkgs.length) return;
    function sync() {
      pkgs.forEach(function (p) {
        var radio = p.querySelector('input[type="radio"]');
        if (radio) {
          p.classList.toggle('pkg--active', radio.checked);
        }
      });
    }
    pkgs.forEach(function (pkg) {
      var radio = pkg.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', sync);
      } else {
        // sin radio (preview): activar al hacer clic
        pkg.addEventListener('click', function () {
          pkgs.forEach(function (p) { p.classList.remove('pkg--active'); });
          pkg.classList.add('pkg--active');
        });
      }
    });
    sync();
  }

  function init() {
    initStickyBar();
    initPackages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
